import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import { VStack, Section } from 'tio-ui/components/layout';
import Heading from 'tio-ui/components/heading';
import Text from 'tio-ui/components/text';
import Button from 'tio-ui/components/button';
import { t } from 'ember-intl';
import DataIndicator from 'tio-employee/components/reimagined/data-indicator';
import type { DataSource } from 'tio-employee/components/reimagined/data-indicator';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type { DataSourceInfo, LiveTasData } from 'tio-employee/services/reimagined-data';

interface TasProgramNewModel {
  tasData: LiveTasData;
  tasUsedAmount: { yearToDate: number; isLiveData: boolean };
  dataSourceInfo: DataSourceInfo;
  programId: string;
}

interface TasProgramNewSignature {
  Args: {
    model: TasProgramNewModel;
  };
}

export default class CareerPathwaysTasProgramNew extends Component<TasProgramNewSignature> {
  @service declare reimaginedData: ReimaginedDataService;

  get isDemoMode() {
    return this.reimaginedData.isDemoMode;
  }

  get tasSource(): DataSource {
    if (this.isDemoMode) return 'demo';
    return this.args.model.tasData.isLiveData ? 'live' : 'placeholder';
  }

  <template>
    <VStack class="gap-6">
      <div class="tio-col-tight">
        <Heading @level={{1}}>{{t "common.start"}}</Heading>
        <Text @variant="muted">{{t "common.programs"}}</Text>
      </div>

      <DataIndicator @source={{this.tasSource}} @showBadge={{true}} @dataSourceId="tas-program-new">
        <Section>
          <:header>
            {{t "common.get_started"}}
          </:header>
          <:body>
            <Text @variant="muted">
              {{t "tas.dashboard.eligible_benefits"}}
            </Text>
            <div class="mt-4">
              <LinkTo @route="authenticated.tas.programs.new-guided" @model={{@model.programId}}>
                <Button @intent="primary">{{t "common.start"}}</Button>
              </LinkTo>
            </div>
          </:body>
        </Section>
      </DataIndicator>
    </VStack>
  </template>
}
